import axios from 'axios';


const IS_DEV = process.env.NODE_ENV === 'development';
const $host = axios.create({
  baseURL: !IS_DEV ? process.env.REACT_APP_BASE_URL : process.env.REACT_APP_BASE_URL_DEV
});

const authInterceptor = config => {
  const token = localStorage.getItem('authorization');
  if (token) {
    config.headers.authorization = 'Bearer ' + token;
  }
  return config;
};

$host.interceptors.request.use(authInterceptor);

$host.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 429) {
      error.response.data = {
        ...error.response.data,
        message: error.response.data?.message || 'Too many requests. Please try again later.'
      };
    }
    return Promise.reject(error);
  }
);

export { $host };
